import { TinyColor } from '@ctrl/tinycolor';
import { reduce, get } from 'lodash';
import { POST_TEXT_COLOR, POST_TITLE_COLOR, LINK_AND_HASHTAG_COLOR, } from '../../../constants/wix-params';
import { getPresetColor, getSiteColor } from '../../../services/colors';
export const getTextColorSchema = (appSettings = {}) => {
    const colors = [
        getSiteColor(appSettings, {
            wixParam: POST_TEXT_COLOR,
            presetFallback: 'color-5',
            colorFallback: '#00000',
        }),
        getSiteColor(appSettings, {
            wixParam: POST_TITLE_COLOR,
            presetFallback: 'color-5',
            colorFallback: '#00000',
        }),
        getSiteColor(appSettings, {
            wixParam: LINK_AND_HASHTAG_COLOR,
            presetFallback: 'color-8',
            colorFallback: '#00000',
        }),
        getPresetColor(appSettings, 'color-13'),
        getPresetColor(appSettings, 'color-18'),
        getPresetColor(appSettings, 'color-23'),
    ];
    return reduce(colors, (schema, color, index) => {
        schema[`textColor${index}`] = { color: toHexColor(color), index };
        return schema;
    }, {});
};
export const getButtonColors = (appSettings = {}) => {
    // colors used for ricos button templates
    const colors = {
        color1: getPresetColor(appSettings, 'color-1'),
        color7: getPresetColor(appSettings, 'color-7'),
        color8: getPresetColor(appSettings, 'color-8'),
    };
    return colors;
};
export const mergeUserAndSiteColors = (userColors, colorSchema) => {
    const siteColors = Object.values(colorSchema);
    return [...siteColors, ...userColors];
};
const toHexColor = (color) => new TinyColor(color).toHexString();
export const styleSelectionPredicate = (colorScheme, richContent) => (inlineStyle) => (colorScheme[inlineStyle] &&
    richContent.isHexColor(colorScheme[inlineStyle].color)) ||
    richContent.isHexColor(inlineStyle);
export const viewerCustomStyleFn = (colorScheme, richContent) => (inlineStyle) => {
    if (colorScheme[inlineStyle] &&
        richContent.isHexColor(colorScheme[inlineStyle].color)) {
        return { color: colorScheme[inlineStyle].color };
    }
    if (richContent.isHexColor(inlineStyle)) {
        return { color: inlineStyle };
    }
    return {};
};
export const customStyleFn = (viewerCustomStyleFn, richContent) => (inlineStyles) => reduce(inlineStyles.toArray(), (styles, inlineStyle) => (Object.assign(Object.assign({}, styles), viewerCustomStyleFn(inlineStyle, richContent))), {});
export const viewerCustomBackgroundStyleFn = (colorScheme, richContent) => (inlineStyle) => {
    const userColor = get(colorScheme, [inlineStyle, 'color']);
    if (richContent.isHexColor(userColor)) {
        return { backgroundColor: userColor };
    }
    if (richContent.isHexColor(inlineStyle)) {
        return { backgroundColor: inlineStyle };
    }
    return {};
};
//# sourceMappingURL=text-color-utils.js.map